import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import moment from 'logic/moment';

const getTranslation = (status) => {
  switch (status) {
    case 'VALIDATION_ASKED': {
      return (
        <FormattedMessage
          id="Waiting for review"
          defaultMessage="Waiting for review"
        />
      );
    }

    case 'CREATED': {
      return (
        <FormattedMessage
          id="Created"
          defaultMessage="Created"
        />
      );
    }

    case 'VALIDATED': {
      return (
        <FormattedMessage
          id="Validated"
          defaultMessage="Validated"
        />
      );
    }

    case 'REFUSED': {
      return (
        <FormattedMessage
          id="Sorry but it’s not accepted"
          defaultMessage="Sorry but it’s not accepted"
        />
      );
    }

    default: {
      return status;
    }
  }
};

const UploadedDocuments = ({ uploadedKyc }) => {
  return (
    <Box position="relative" display="flex" justifyContent="center">
      <Box style={{ width: '530px' }}>
        {uploadedKyc.map((item, i) => (
          <Box key={i} textAlign="left" borderBottom="1px dashed #cfcfcf" my={2}>
            <Typography>
              <FormattedMessage
                id="userform.documentType"
                defaultMessage="Document Type"
              /> : {item.Type}
            </Typography>
            <Typography>
              <FormattedMessage
                id="userform.uploadedDate"
                defaultMessage="Uploaded Date"
              /> : {moment.unix(item.CreationDate).format('L LT')}
            </Typography>
            {item.ProcessedDate && (
              <Typography>
                <FormattedMessage
                  id="userform.processedDate"
                  defaultMessage="Processed Date"
                /> : {moment.unix(item.ProcessedDate).format('L LT')}
              </Typography>
            )}
            <Typography>
              {getTranslation(item.Status)}
            </Typography>
            {item.RefusedReasonMessage && (
              <Typography>
                <FormattedMessage
                  id="userForm.idBankError"
                  defaultMessage="You have uploaded your images but then it have been denied by the bank"
                />{' '}
                {item.RefusedReasonMessage}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

UploadedDocuments.propTypes = {
  uploadedKyc: PropTypes.arrayOf(PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Type: PropTypes.string,
    CreationDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ProcessedDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Status: PropTypes.oneOf(['VALIDATED', 'REFUSED', 'VALIDATION_ASKED', 'CREATED', 'OUT_OF_DATE']),
    RefusedReasonMessage: PropTypes.string,
  })),
};

export default UploadedDocuments;
